import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { configureAuth } from './config/auth';
import './index.css';

// Configure AWS Amplify for authentication
configureAuth();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
